import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from '../common.js'
import {
  getMyCoupon_mock,
  getTip_mock,
  getPopus_mock,
  saveCoupon_mock,
  getAvailableCoupon_mock,
  getCalculatePrice_mock,
} from '../mock'
import { getUvid } from '@/utils/uvid'
import { getFid } from '@/utils/fid'
import { fixSource } from '@/utils/request_helper'

// const http_request_mode = 'mock' // 是否启用mock
const http_request_mode = 'http' // 是否启用mock

// 查询当前套餐可用的优惠券列表
export function getAvailableCoupon(options, showLoading = false) {
  if (http_request_mode === 'mock') {
    return getAvailableCoupon_mock()
  }
  return request.postJson(
    {
      url: appendApiUrl('/activity/available/coupon'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading,
    }
  )
}

// 获取勾选套餐累计金额
export function getCalculatePrice(options) {
  if (http_request_mode === 'mock') {
    return getCalculatePrice_mock()
  }
  return request.postJson(
    {
      url: appendApiUrl('/activity/calculatePrice'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
    }
  )
}

// 查询用户的优惠券列表
export const getMyCoupon = (country) => {
  if (http_request_mode === 'mock') {
    return getMyCoupon_mock()
  }
  return request.get(
    {
      url: appendApiUrl(`/activity/myCoupon?country=${country}`),
    },
    {
      showLoading: false,
    }
  )
}

// 用户登陆后，查询符合条件的活动弹窗
export const getPopus = (country, game, source) => {
  if (http_request_mode === 'mock') {
    return getPopus_mock()
  }

  const { source: newSource } = fixSource({ source }) || {}
  return request.get(
    {
      url: appendApiUrl(
        `/activity/popus?country=${country}&game=${game}&source=${newSource}`
      ),
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}

// 用户领券接口
export function saveCoupon(options) {
  if (http_request_mode === 'mock') {
    return saveCoupon_mock()
  }
  return request.postJson(
    {
      url: appendApiUrl('/activity/save/coupon'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    },
    {
      uvid: getUvid(),
      fid: getFid(),
    }
  )
}

// 用户未登录时，查询未登录提示图片链接
export const getTip = (country, game, source) => {
  if (http_request_mode === 'mock') {
    return getTip_mock()
  }
  const { source: newSource } = fixSource({ source }) || {}
  return request.get(
    {
      url: appendApiUrl(
        `/activity/tip?country=${country}&game=${game}&source=${newSource}`
      ),
    },
    {
      showLoading: false,
    }
  )
}

// 根据活动id查活动关联优惠券信息
export const getByActivityId = (options = {}) => {
  if (http_request_mode === 'mock') {
    return getPopus_mock()
  }
  return request.get(
    {
      url: appendApiUrl(
        `/activity/getByActivityId?activityId=${options.activityId}`
      ),
    },
    {
      showLoading: false,
    }
  )
}

// 深色版本
// 优惠券游戏列表
export const getMyCouponGames = (options) => {
  return request.postJson(
    {
      url: appendApiUrl(`/activity/myCoupon/games`),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: true,
    }
  )
}

// 深色版本
// 查询用户的优惠券列表
export const getMyCouponList = (options) => {
  return request.postJson(
    {
      url: appendApiUrl(`/activity/myCoupon/v2`),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: true,
    }
  )
}
